import productType from '../../config/productType';

const mixin = {
  data() {
    return {
      Model: {
        productName: null,
        productType: null,
        productRecordCode: null,
        productFoundingDate: null,
        productRecordDate: null,
        productRecordNo: null,
        productSurvivalPeriod: null,
        productScale: '',
        productManager: '',
        productDeposit: null,
      },
      options: {
        scrollToInvalidField: false,
      },
      Fields: [
        {
          type: 'input',
          modelKey: 'productName',
          label: '产品名称',
          props: {
            type: 'text',
            readonly: true,
          },
        },
        {
          type: 'select',
          modelKey: 'productType',
          label: '产品类型',
          props: {
            options: [...productType],
            readonly: true,
            placeholder: '请选择产品类型',
          },
          rules: {
            required: true,
          },
          messages: {
            required: '请选择产品类型',
          },
        },
        {
          modelKey: 'productFoundingDate',
          label: '成立时间',
          rules: {
            required: true,
          },
          messages: {
            required: '请选择机构类型',
          },
        },
        {
          type: 'input',
          modelKey: 'productRecordCode',
          label: '备案机构',
          props: {
            type: 'text',
            clearable: true,
            placeholder: '请输入产品备案机构',
          },
          rules: {
            required: true,
            notWhitespace: true,
          },
          messages: {
            required: '请输入产品备案机构',
          },
        },
        {
          modelKey: 'productRecordDate',
          label: '备案时间',
          rules: {
            required: true,
          },
          messages: {
            required: '请选择备案时间',
          },
        },
        {
          type: 'input',
          modelKey: 'productRecordNo',
          label: '备案编号',
          props: {
            type: 'text',
            clearable: true,
            placeholder: '请输入产品备案编号',
          },
          rules: {
            required: true,
            notWhitespace: true,
          },
          messages: {
            required: '请输入产品备案编号',
          },
        },
        {
          type: 'input',
          modelKey: 'productSurvivalPeriod',
          label: '存续期(年)',
          props: {
            type: 'number',
            clearable: true,
            placeholder: '请输入产品存续期',
          },
          rules: {
            required: true,
            type: 'number',
            notWhitespace: true,
            custom: val => val < 100,
          },
          messages: {
            required: '请输入产品存续期',
            custom: '请输入产品存续期',
          },
        },
        {
          type: 'input',
          modelKey: 'productScale',
          label: '规模(万)',
          props: {
            type: 'number',
            clearable: true,
            placeholder: '请输入产品规模',
          },
          rules: {
            required: true,
            type: 'number',
            notWhitespace: true,
            custom: val => val < 1000000000000,
          },
          messages: {
            required: '请输入产品规模',
            custom: '土豪，您太有钱了',
          },
        },
        {
          type: 'input',
          modelKey: 'productManager',
          label: '管理人',
          props: {
            type: 'text',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'productDeposit',
          label: '托管人',
          props: {
            type: 'text',
            clearable: true,
            placeholder: '请输入产品托管人',
          },
          rules: {
            required: true,
            notWhitespace: true,
          },
          messages: {
            required: '请输入产品托管人',
          },
        },
      ],
    };
  },
  methods: {
    $_handleShowDatePicker(type) {
      if (type === 'productFoundingDate') {
        this.$createDatePicker({
          title: '成立时间',
          min: new Date(1999, 12, 1),
          max: new Date(2099, 11, 31),
          format: {
            year: 'YYYY',
            month: 'MM',
            date: 'DD',
          },
          value:
            this.Model.productFoundingDate
              ? new Date(this.Model.productFoundingDate)
              : new Date(),
          onSelect: (date, selectedVal) => {
            this.$set(this.Model, 'productFoundingDate', selectedVal.join('-'));
          },
          onCancel: () => {
          },
        }).show();
      }
      if (type === 'productRecordDate') {
        this.$createDatePicker({
          title: '备案时间',
          min: new Date(1999, 12, 1),
          max: new Date(2099, 11, 31),
          format: {
            year: 'YYYY',
            month: 'MM',
            date: 'DD',
          },
          value:
            this.Model.productRecordDate
              ? new Date(this.Model.productRecordDate)
              : new Date(),
          onSelect: (date, selectedVal) => {
            this.$set(this.Model, 'productRecordDate', selectedVal.join('-'));
          },
          onCancel: () => {
          },
        }).show();
      }
    },
  },
};
export default mixin;
